module.exports = __webpack_public_path__ + "src/assets/img/volume-up.de3124b1.svg";